/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * customerCardTypes.ts — shared customer-card types and localization mappings.
 * It re-exports the authoritative workspace contracts and maps built-in field
 * identifiers to catalog keys. User-facing strings must remain in catalogs so
 * domain models do not silently pin the operator interface to one language.
 */

/**
 * Re-export customer card types from store for use in UI.
 * Plan: arm-operator/05_client_card_workspace.
 */
export type {
  CustomerCard,
  CustomerCardL1,
  ScenarioFieldValue,
  FieldSource,
} from '@/store/slices/workspaceSlice';

export const DEFAULT_SCENARIO_FIELD_IDS = ['date', 'time', 'address', 'topic', 'notes'] as const;

/** Maps built-in scenario fields to localized UI catalog keys. */
export const SCENARIO_FIELD_I18N_KEYS: Record<string, string> = {
  date: 'scenario.date',
  time: 'scenario.time',
  address: 'scenario.address',
  topic: 'scenario.topic',
  notes: 'scenario.notes',
};
